import LayoutFooter, { getFooterDataSource } from "@/components/LayoutFooter";
import ConsultationQr from "@/components/SideButtonList/ConsultationQr";
import useAppStore from "@/context/store";
import Content from "@/pageComponents/Consult/Content";
import { LeadsEntrance } from "@/pageComponents/Consult/FormModal";
import Header from "@/pageComponents/Consult/Header";
import { useAutoPotentialCluesPush } from "@/pageComponents/Consult/useAutoPotentialCluesPush";

import { getGrocery } from "@/services";
import { useScroll } from "ahooks";
import classNames from "classnames";
import Head from "next/head";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
const OTHER = "other";

export async function getServerSideProps({ req, query }) {
  const dataSource = await getFooterDataSource({
    query,
    seoLinkInfo: {
      currentUrl: req.url,
    },
  });
  return {
    props: {
      footerDataSource: dataSource,
    },
  };
}

export default function VipConsultPage({ footerDataSource }) {
  const router = useRouter();

  const [config, setConfig] = useState(null);
  const isMobile = useAppStore((s) => s.isMobile);
  const scroll = useScroll(() => document);
  const queryConfig = useCallback(async () => {
    const result = await getGrocery("company-consult-v2");
    setConfig(result);
  }, []);

  useEffect(() => {
    queryConfig();
  }, [queryConfig]);
  const query = router.query;
  const qrcodeImg = useMemo(() => {
    const { leads_entrance = OTHER } = query;
    const qrcode = config?.qrcodeList?.find(
      (item) => item.leads_entrance === leads_entrance
    )?.img[0].url;

    // 如果没有找到匹配的二维码，尝试使用默认的 "other" 二维码
    return (
      qrcode ||
      config?.qrcodeList?.find((item) => item.leads_entrance === OTHER)?.img[0]
        .url
    );
  }, [query, config]);

  useAutoPotentialCluesPush();

  return (
    <>
      <Head>
        <title>花瓣素材大企业授权定制</title>
      </Head>
      <h1 style={{ display: "none" }}>花瓣素材大企业授权定制</h1>
      <div
        className={classNames([styles.page, isMobile ? styles.mobile : null])}
      >
        <img
          alt=""
          className={styles.headerImg}
          src={
            isMobile ? config?.bannerMobile?.[0]?.url : config?.banner?.[0]?.url
          }
        ></img>
        <When condition={isMobile}>
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0,user-scalable=no"
            />
          </Head>
        </When>

        <div className={styles.container}>
          <Header
            config={config}
            isMobile={isMobile}
            qrcodeImg={qrcodeImg}
          ></Header>
        </div>
        <div className={styles.bg}>
          <Content config={config} isMobile={isMobile}></Content>
        </div>
        <When condition={!isMobile && scroll?.top > 520}>
          <ConsultationQr
            className={styles.stickyQrcode}
            leads_entrance={LeadsEntrance.ConsultSidebar}
          />
        </When>
        <When condition={!isMobile}>
          <LayoutFooter dataSource={footerDataSource} />
        </When>
      </div>
    </>
  );
}
